import { createContext } from 'use-context-selector';

import { ThemePaletteColor, ThemeGradientColor } from '../../types';

interface PageContextProps {
  background?: ThemePaletteColor;
  headerBackground: ThemePaletteColor | ThemeGradientColor;
}

export const PageContext = createContext<PageContextProps>({
  headerBackground: 'transparent',
  background: 'white100',
});
